export const ONBOARDING_PAGE_NS = 'pages/OnboardingPage';

export const i18n = {
  en: {
    title: 'Onboarding',
    buttons: {
      back: 'Back',
      continue: 'Continue',
    },
    error: {
      ecosystem: {
        validation: {
          symbols: 'Special characters and spaces aren’t allowed.',
          invalid: 'Name doesn’t look quite right. Try again!',
          short: 'Ecosystem name needs to be at least 3 characters long.',
          repeat: 'Please avoid using 3 or more repeated characters in a row.',
          exist: 'Looks like this name is already taken.',
          reserved: 'This name is reserved. Contact Rise-X support for help.',
        },
      },
    },
    stepper: '{{currentStep}} of {{totalSteps}} steps',
    industries: {
      technology: 'Technology and Innovation',
      goods: 'Retail and Consumer Goods',
      food: 'Food and Hospitality',
      healthcare: 'Healthcare and Wellness',
      construction: 'Construction and Real Estate',
      finance: 'Finance and Business Services',
      arts: 'Arts, Media, and Entertainment',
      transportation: 'Transportation and Logistics',
      education: 'Education and Training',
      agriculture: 'Agriculture and Natural Resources',
      manufacturing: 'Manufacturing and Industrial',
      energy: 'Energy and Utilities',
      services: 'Personal and Professional Services',
      sector: 'Public Sector and Non-Profit',
      other: 'Other',
    },
    keyAreas: {
      supply: {
        area: 'Supply chain management',
        tooltip: 'e.g.: procurement, vendor coordination',
      },
      asset: {
        area: 'Asset management',
        tooltip: 'e.g.: lifecycle tracking, maintenance workflows',
      },
      logistics: {
        area: 'Logistics & Distribution',
        tooltip: 'e.g.:  delivery tracking, route optimisation',
      },
      operations: {
        area: 'Operations',
        tooltip: 'e.g.:  project planning, cross-department workflows',
      },
      compliance: {
        area: 'Compliance & Risk',
        tooltip: 'e.g.:  audits, policy enforcement, reporting',
      },
      sustainability: {
        area: 'Sustainability',
        tooltip: 'e.g.: ESG reporting, waste reduction workflows',
      },
      human: { area: 'Human resources', tooltip: 'e.g.: onboarding, performance tracking' },
      customer: {
        area: 'Customer experience',
        tooltip: 'e.g.: feedback collection, customer support coordination',
      },
      other: { area: 'Other' },
    },
    steps: {
      business: {
        component: {
          title: 'Tell us about your business',
          description: 'We will use it to generate workflows tailored for your business needs.',
          form: {
            company: {
              label: 'Company name',
              placeholder: 'Enter your company name',
            },
            ecosystem: {
              label: 'Ecosystem name',
              placeholder: 'Enter ecosystem name',
              hint: 'Your ecosystem name will appear in your unique ecosystem URL, making it easy to share with your team',
            },
            industry: {
              label: 'Industry',
              placeholder: 'Type to search or select',
            },
            website: {
              label: 'Website URL',
              placeholder: 'Enter your company website',
            },
          },
        },
        banner: {
          title: 'Why it matters?',
          description:
            'We customise workflows based on your industry and company details, saving you time from day one.',
        },
      },
      keyAreas: {
        component: {
          title: 'Choose your focus areas',
          description: 'Select at least 1 area to help us customise your workflows.',
          suggestions: 'AI suggestions',
        },
        banner: {
          title: 'Optimise your key business processes',
          description:
            'Rise-X suggests workflows that best fit your business needs, helping you optimise operations in the areas that matter most.',
        },
      },
      ecosystem: {
        component: {
          title: 'Make it yours',
          description: 'All customisations are optional - you can always update these later.',
          color: 'Brand colour',
          theme: 'Default theme',
        },
        banner: {
          title: 'What is ecosystem?',
          description:
            'By setting up an ecosystem, you create a central hub for managing workflows, data, and collaboration, designed specifically for your business needs.',
        },
      },
    },
  },
};
